import { NonLinear } from '@lib/iab/iab-vast-model';

import createClick from './click';
import createResource from './resource';
import hasValue from '../util/has-value';

interface UnmarshalerNode {
    _value: unknown;
    [key: string]: unknown;
}

const createNonLinear = ($nonLinear: UnmarshalerNode): NonLinear => {
    const nonLinear = new NonLinear();
    nonLinear.id = $nonLinear.id as string;
    nonLinear.width = $nonLinear.width as number;
    nonLinear.height = $nonLinear.height as number;
    nonLinear.expandedWidth = $nonLinear.expandedWidth as number;
    nonLinear.expandedHeight = $nonLinear.expandedHeight as number;
    nonLinear.scalable = $nonLinear.scalable as boolean;
    nonLinear.maintainAspectRatio = $nonLinear.maintainAspectRatio as boolean;
    nonLinear.minSuggestedDuration = $nonLinear.minSuggestedDuration as number;
    nonLinear.apiFramework = $nonLinear.apiFramework as string;
    nonLinear.resource = createResource($nonLinear);

    if ($nonLinear.adParameters != null) {
        nonLinear.adParameters = ($nonLinear.adParameters as UnmarshalerNode)
            ._value as string;
    }

    if (
        $nonLinear.nonLinearClickThrough != null &&
        hasValue($nonLinear.nonLinearClickThrough)
    ) {
        nonLinear.clickThrough = createClick(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $nonLinear.nonLinearClickThrough as any
        );
    }

    if ($nonLinear.nonLinearClickTracking != null) {
        nonLinear.clickTrackings.push(
            ...($nonLinear.nonLinearClickTracking as UnmarshalerNode[])
                .filter(hasValue)
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map((click: UnmarshalerNode) => createClick(click as any))
        );
    }

    return nonLinear;
};

export default createNonLinear;
